export function getExtensionVersion(): Promise<string | null> {
  return new Promise((resolve) => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data.type === 'EXTENSION_VERSION_RESPONSE') {
        window.removeEventListener('message', handleMessage);
        resolve(event.data.success ? event.data.version : null);
      }
    };
    window.addEventListener('message', handleMessage);
    window.postMessage({ type: 'EXTENSION_GET_VERSION' }, '*');
    setTimeout(() => { window.removeEventListener('message', handleMessage); resolve(null); }, 2000);
  });
}
